export const URIOptions: any[] = [
    {
      id: 1,
      title: '5',
      description : 'The Basic license allows you to install the DataBus and try out its main features for free.All configuration made is stored in an in-memory database and won\'t persist between restarts',
      dashboards: '1',
      connectors: '2',
      input_Items: 5,
      email_Support: false,
      phone_support: false,
      price: 0
    },
    {
      id: 2,
      title: '50',
      description : 'The 20 point license allows for a single install of the DataBus for the replication of up to 50 data points.',
      dashboards: '2',
      connectors: '5',
      input_Items: 50,
      email_Support: true,
      phone_support: false,
      price: 500
    },

    {
      id: 3,
      title: '500',
      description : ' The 400 point license allows for a single install of the DataBus for the replication of up to 500 data points.',
      dashboards: '10',
      connectors: '50',
      input_Items: 500,
      email_Support: true,
      phone_support: false,
      price: 3000

    },

    {
      id: 4,
      title: '1000',
      description : ' The 1000 point license allows for a single install of the DataBus for the replication of up to 1000 data points.',
      dashboards: '10',
      connectors: '50',
      input_Items: 1000,
      email_Support: true,
      phone_support: false,
      price: 5000
    },

    {
      id: 5,
      title: '5000',
      description : ' The 5000 point license allows for a single install of the DataBus for the replication of up to 5000 data points.',
      dashboards: '10',
      connectors: '50',
      input_Items: 5000,
      email_Support: true,
      phone_support: true,
      price: 10000
    },

    /*{
      id: 6,
      title: 'Site License',
      description : ' The site license allows for unlimited install of the DataBus for unlimited data points.',
      dashboards: 'Unlimited',
      connectors: 'Unlimited',
      input_Items: 'Unlimited',
      email_Support: true,
      phone_support: true,
      price: 20000
    },*/

  ];

export const PluginCategories: any[] = [
    {
        id: 1,
        name: 'CloudTechnology'
    },

    {
        id: 2,
        name: 'Azure'
    },

    {
        id: 3,
        name: 'InternetOfThings'
    },

    {
        id: 4,
        name: 'Databases'
    },

    {
        id: 5,
        name: 'SpecialtyPlatforms'
    },

  ];

export const STATES: any[] = [
    { id: 1, name: 'TAS' },
    { id: 2, name: 'QLD' },
    { id: 3, name: 'VIC' },
    { id: 4, name: 'NSW' }
  ];

